/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_Meal_PrepInputs */

const en_recipe_meal_prep = /** @type {(inputs: Recipe_Meal_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meal prep`)
};

const de_recipe_meal_prep = /** @type {(inputs: Recipe_Meal_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meal-Prep`)
};

/**
* | output |
* | --- |
* | "Meal prep" |
*
* @param {Recipe_Meal_PrepInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_meal_prep = /** @type {((inputs?: Recipe_Meal_PrepInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Meal_PrepInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_meal_prep(inputs)
	return en_recipe_meal_prep(inputs)
});